import { Checkbox } from 'antd';
import { useState } from 'react';
import { styled } from 'styled-components';
import PhoneCaseImage from '../../assets/images/phone-case.png';
import PosterImage from '../../assets/images/poster.png';
import StickerImage from '../../assets/images/sticker.png';
// TODO(design): replace with a dedicated Magnet Sticker illustration when available.
import MagnetStickerImage from '../../assets/images/sticker.png';
import UVDTFImage from '../../assets/images/uvdtf.png';
// TODO(design): replace with a dedicated Card Skin illustration when available.
import CardSkinImage from '../../assets/images/sticker.png';
// TODO(design): replace with a dedicated Badge Reel illustration when available.
import BadgeReelImage from '../../assets/images/badge_reel.png';
// TODO(design): replace with a dedicated Glass Suncatcher illustration when available.
import SquishyBellyImage from '../../assets/images/squishy-belly.png';
import GlassSuncatcherImage from '../../assets/images/suncatcher.png';
// TODO(design): replace with a dedicated Ornament illustration when available.
import OrnamentImage from '../../assets/images/suncatcher.png';
import { PRODUCT_TYPE_CHOICE_KEY } from '../../constants/order';
import { OrderType } from '../../interfaces/Order';
import {
  StyledOrderTypeSelectContainer,
  StyledOrderTypeSelectItem,
} from '../Order/Order.styled';
import BaseModal from './BaseModal/BaseModal';

export interface IProps {
  visible: boolean;
  onSelectType: (type: OrderType) => void;
  onCancel?: () => void;
}

const OrderTypePromptModal = (props: IProps) => {
  const { visible, onSelectType, onCancel } = props;
  const [rememberChoice, setRememberChoice] = useState(false);

  const onSelect = (type: OrderType) => {
    if (rememberChoice) {
      localStorage.setItem(PRODUCT_TYPE_CHOICE_KEY, JSON.stringify(type));
    }
    onSelectType(type);
  };
  return (
    <StyledModal
      visibleModal={visible}
      title="Select Product"
      onPrimaryBtnClick={() => {
        onSelectType(OrderType.PhoneCase);
      }}
      onSecondaryBtnClick={() => {
        onCancel?.();
      }}
      destroyOnClose={true}
      footer={<div></div>}
      titleAlign="left"
      headerPadding="0"
    >
      <StyledOrderTypeSelectContainer>
        <Checkbox
          onChange={() => setRememberChoice(!rememberChoice)}
          value={rememberChoice}
          className="m__b--10"
        >
          Remember This Choice
        </Checkbox>
        <StyledOrderTypeSelectItem
          key="2"
          onClick={() => onSelect(OrderType.Sticker)}
        >
          <img src={StickerImage} alt="Sticker" width={24} height={24} />
          <p>Create Sticker Order</p>
        </StyledOrderTypeSelectItem>
        <StyledOrderTypeSelectItem
          key="8"
          onClick={() => onSelect(OrderType.MagnetSticker)}
        >
          <img
            src={MagnetStickerImage}
            alt="Magnet Sticker"
            width={24}
            height={24}
          />
          <p>Create Magnet Sticker Order</p>
        </StyledOrderTypeSelectItem>
        <StyledOrderTypeSelectItem
          key="3"
          onClick={() => onSelect(OrderType.UVDTF)}
        >
          <img src={UVDTFImage} alt="UVDTF" width={24} height={24} />
          <p>Create UVDTF Order</p>
        </StyledOrderTypeSelectItem>
        <StyledOrderTypeSelectItem
          key="4"
          onClick={() => onSelect(OrderType.PhoneCase)}
        >
          <img src={PhoneCaseImage} alt="Phone Case" width={24} height={24} />
          <p>Create Phone Case Order</p>
        </StyledOrderTypeSelectItem>
        <StyledOrderTypeSelectItem
          key="1"
          onClick={() => onSelect(OrderType.Poster)}
        >
          <img src={PosterImage} alt="Poster" width={24} height={24} />
          <p>Create Poster Order</p>
        </StyledOrderTypeSelectItem>
        <StyledOrderTypeSelectItem
          key="5"
          onClick={() => onSelect(OrderType.BadgeReel)}
        >
          <img src={BadgeReelImage} alt="Badge Reel" width={24} height={24} />
          <p>Create Badge Reel Order</p>
        </StyledOrderTypeSelectItem>
        <StyledOrderTypeSelectItem
          key="6"
          onClick={() => onSelect(OrderType.GlassSuncatcher)}
        >
          <img
            src={GlassSuncatcherImage}
            alt="Glass Suncatcher"
            width={24}
            height={24}
          />
          <p>Create Glass Suncatcher Order</p>
        </StyledOrderTypeSelectItem>
        <StyledOrderTypeSelectItem
          key="7"
          onClick={() => onSelect(OrderType.SquishyBelly)}
        >
          <img
            src={SquishyBellyImage}
            alt="Squishy Belly"
            width={24}
            height={24}
          />
          <p>Create Squishy Belly Order</p>
        </StyledOrderTypeSelectItem>
        <StyledOrderTypeSelectItem
          key="9"
          onClick={() => onSelect(OrderType.CardSkin)}
        >
          <img src={CardSkinImage} alt="Card Skin" width={24} height={24} />
          <p>Create Card Skin Order</p>
        </StyledOrderTypeSelectItem>
        <StyledOrderTypeSelectItem
          key="10"
          onClick={() => onSelect(OrderType.Ornament)}
        >
          <img src={OrnamentImage} alt="Ornament" width={24} height={24} />
          <p>Create Ornament Order</p>
        </StyledOrderTypeSelectItem>
      </StyledOrderTypeSelectContainer>
    </StyledModal>
  );
};

export default OrderTypePromptModal;

const StyledModal = styled(BaseModal)`
  &.ant-modal {
    width: 640px !important;
  }
`;
